import { render, staticRenderFns } from "./PersonPackageTable.vue?vue&type=template&id=4344919e&scoped=true"
import script from "./PersonPackageTable.vue?vue&type=script&lang=js"
export * from "./PersonPackageTable.vue?vue&type=script&lang=js"
import style0 from "./PersonPackageTable.vue?vue&type=style&index=0&id=4344919e&prod&lang=scss&scoped=true"
import style1 from "./PersonPackageTable.vue?vue&type=style&index=1&id=4344919e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4344919e",
  null
  
)

export default component.exports